import YAxis from './YAxis';
export default YAxis;